exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host ::ng-deep .ui-sidebar {\n  padding: 0;\n  border: 0; }\n\n:host ::ng-deep .ui-sidebar-close {\n  display: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project/components/project/project.component.scss
// module id = ../../../../../src/app/modules/project/components/project/project.component.scss
// module chunks = main